import { memo } from 'react';
import CopyAll from '@mui/icons-material/CopyAll';
import { IconButton, Tooltip } from '@mui/material';

import { InterviewCreationFormValues } from './types';

interface Props {
    groupId: string;
    interviewId: string;
    setInterviewCreationForm: (value: InterviewCreationFormValues) => void;
}

const InterviewMenuCopyButton = ({ groupId, interviewId, setInterviewCreationForm }: Props) => {
    return (
        <Tooltip placement="right" title={`Duplicate Survey?`}>
            <span className="appear-item">
                <IconButton
                    color="success"
                    onClick={(e) => {
                        e.stopPropagation();
                        setInterviewCreationForm({
                            groupId,
                            baseGroupId: groupId,
                            baseInterviewId: interviewId,
                        });
                    }}
                >
                    <CopyAll />
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default memo(InterviewMenuCopyButton);
